import React from "react";
import {observer} from "mobx-react-lite";
import {Button, ButtonGroup, FormControl, Grid, InputLabel, MenuItem, Select} from "@mui/material";
import {useStores} from "../../../../stores";
import {ChevronRight, Close, FilterAlt} from "@mui/icons-material";
import {MultiTypedSearchComponent} from "../../../../components/search/MultiTypedSearchComponent";
import {environment} from "../../../../env";
import {generatePath, useNavigate, useParams} from "react-router";
import {routes} from "../../../../routing/routes";
import {getDashboardEnv} from "../../../multi-dashboard/merge-x-cleanup-dashboard/constants";

export const ReviewFilterBar: React.FC = observer(() => {
    const {p, categorizationReviewStore, rootAppStore} = useStores();
    const navigate = useNavigate();
    const params = useParams();
    const reviewPageController = categorizationReviewStore.reviewPageController;
    const reviewPageFilterController = categorizationReviewStore.reviewPageController.reviewPageFilterController;
    const showSampleOverview = categorizationReviewStore.isValidationBag;

    const groupBy = reviewPageController.singleMode ? 'parts' : 'suppliers';
    const groupByLabel = 'Group by';

    return <Grid container className="review-filter-bar" spacing={2}>

        {!p.p.hideGroupBySupplier &&
            <Grid item xs={1}>
                <FormControl fullWidth>
                    <InputLabel id="review-filter-bar-taxonomy-dropdown-label">{groupByLabel}</InputLabel>
                    <Select
                        labelId="review-filter-bar-taxonomy-dropdown-label"
                        id="review-filter-bar-taxonomy-dropdown"
                        label={groupByLabel}
                        onChange={(event) => {
                            const singleMode = event.target.value === 'parts'
                            reviewPageController.setSingleMode(singleMode)
                        }}
                        value={groupBy}>
                        <MenuItem value={'suppliers'}>{p.supplierDataName}</MenuItem>
                        <MenuItem value={'parts'}>None</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        }

        <Grid item xs={groupBy === 'parts' ? 5 : 3}>
            {groupBy === 'parts'
                ? <MultiTypedSearchComponent
                    id="part-search"
                    manager={reviewPageFilterController.partsSearchManager}
                />
                : <MultiTypedSearchComponent
                    id="supplier-search"
                    manager={reviewPageFilterController.suppliersSearchManager}
                />
            }
        </Grid>

        <Grid item style={{flexGrow: 1}}/>

        {!showSampleOverview &&
            <Grid item>
                <Button
                    color="primary"
                    variant="outlined"
                    className="toolbar-btn"
                    startIcon={<ChevronRight/>}
                    onClick={() => {
                        if (environment.package === 'merge_x') {
                            navigate(generatePath(routes.merge_x_cleanup_categorization_statistics, params));
                        } else if (environment.package === 'merge_x_cleanup') {
                            if (getDashboardEnv(rootAppStore.app) === 'synergy') {
                                navigate(generatePath(routes.merge_xc_combined_categorization_statistics, params));
                            } else {
                                navigate(generatePath(routes.merge_xc_single_categorization_statistics, params));
                            }
                        } else if (environment.package === 'cleanup') {
                            navigate(generatePath(routes.categorization_statistics, params));
                        } else if (environment.package === 'merge_2') {
                            navigate(generatePath(routes.merge_2_cleanup_categorization_statistics, params));
                        } else {
                            throw new Error(`Missing categorization_statistics route for package ${environment.package}`)
                        }
                    }}>
                    See statistics
                </Button>
            </Grid>
        }

        {reviewPageController.singleMode &&
            <Grid item>
                <ButtonGroup className="medium-3-btn-group">
                    <Button
                        endIcon={<FilterAlt/>}
                        variant={reviewPageFilterController.isAdvancedFilterEnabled ? 'contained' : 'outlined'}
                        onClick={() => reviewPageFilterController.setAdvancedFilterDialogOpen(true)}>
                        Filter
                    </Button>
                    {reviewPageFilterController.isAdvancedFilterEnabled &&
                        <Button
                            className="close-option"
                            size="small"
                            variant="outlined"
                            onClick={() => reviewPageFilterController.disableAdvancedFilter()}
                            title="Disable the filter"
                        >
                            <Close/>
                        </Button>
                    }
                </ButtonGroup>
            </Grid>
        }
    </Grid>

})
